import { Search } from 'lucide-react';
import { clsx } from 'clsx';

/** Champ de recherche d'une liste, avec loupe ; label sert d'intitulé (lecteurs d'écran) et de placeholder */
export function SearchInput({
  label,
  value,
  onChange,
  className,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <div className={clsx('relative w-full lg:w-96', className)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4" />
      <input
        type="search"
        aria-label={label}
        placeholder={`${label}...`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg text-sm bg-card focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      />
    </div>
  );
}
